<template>
  <div>
    <Form style="margin-top:20px" :model="formItem" :label-width="150" label-position="left" :disabled="loading">
      <div class="formRow">
        <div class="formCol">
          <FormItem label="部门">
            <Select v-model="formItem.department" :clearable="true" placeholder="" filterable>
              <Option :value="item.department" v-for="item in departmentLabel" :key="item.department">{{ item.department }}</Option>
            </Select>
          </FormItem>
        </div>
        <div class="formCol">
          <FormItem label="职位">
            <Input v-model="formItem.position" />
            <!-- <Select v-model="formItem.position" :clearable="true" placeholder="" filterable>
              <Option :value="item.position" v-for="item in positionLabel" :key="item.department">{{ item.position }}</Option>
            </Select> -->
          </FormItem>
        </div>
        <div class="formCol">
          <FormItem label="考核指标">
            <Input v-model="formItem.assessmentIndex" />
          </FormItem>
        </div>
        <div class="formCol">
          <FormItem label="关键绩效指标">
            <Input v-model="formItem.performanceIndicators" />
          </FormItem>
        </div>
        <div class="formCol">
          <FormItem label="考核标准">
            <Input v-model="formItem.assessmentStandard" />
          </FormItem>
        </div>
        <div class="formCol">
          <Button @click="total=0,pageInfo.pageNo=1,search()"><!-- 检 索 -->{{$t('Search')}}</Button>
        </div>
      </div>
    </Form>
    <Table highlight-row border :columns="columns" :data="data" :loading="loading"></Table>
    <Table border ref="currentRowTable" :columns="columns2" :data="data2" :loading="loading" v-show="false"></Table>
    <Page style="margin-top: 20px; text-align: left" :total="total" @on-change="pageChange" :disabled="loading"/>
    <div style="margin-top: -20px; text-align: right"><Button @click="exportTable" :disabled="loading">导 出</Button></div>
  </div>
</template>

<script>
import axios from "axios";
export default {
  data() {
    return {
      formItem: {},
      columns:[
        {
          title: '部门',
          key: 'department',
          align: 'center',
          minWidth: 120,
        },
        {
          title: '职位',
          key: 'position',
          align: 'center',
          minWidth: 120,
        },
        {
          title: '考核指标',
          key: 'assessmentIndex',
          align: 'center',
          minWidth: 120,
        },
        {
          title: '关键绩效指标',
          key: 'performanceIndicators',
          align: 'center',
          minWidth: 120,
        },
        {
          title: '考核标准（基准）',
          key: 'assessmentStandard',
          align: 'center',
          minWidth: 120,
        },
      ],
      data:[],
      columns2:[
        {
          title: '部门',
          key: 'department',
          align: 'center',
          minWidth: 120,
        },
        {
          title: '职位',
          key: 'position',
          align: 'center',
          minWidth: 120,
        },
        {
          title: '考核指标',
          key: 'assessmentIndex',
          align: 'center',
          minWidth: 120,
        },
        {
          title: '关键绩效指标',
          key: 'performanceIndicators',
          align: 'center',
          minWidth: 120,
        },
        {
          title: '考核标准（基准）',
          key: 'assessmentStandard',
          align: 'center',
          minWidth: 120,
        },
      ],
      data2:[],
      loading:false,
      clickDisabled:false,
      pageInfo: {
        itemCount: 0,
        pageNo: 1,
        pageSize: 10,
      },
      total: 0,
      departmentLabel:[],
      positionLabel:[],
    };
  },
  created(){
    this.getSelection()
    this.search()
  },
  methods: {
    getSelection(){
      axios.post('IndexLibrary/selectIndexLabel',{}).then(res=>{
        this.departmentLabel = res.departmentLabel
        this.positionLabel = res.positionLabel
      })
    },
    search(){
      let obj = {
        ...this.formItem,
        pageNo : this.pageInfo.pageNo,
        pageSize : this.pageInfo.pageSize,
      }
      this.loading = true
      axios.post('IndexLibrary/selectIndexLibrary', obj).then(res=>{
        this.loading = false
        if(res){
          this.data = res.data
          this.total = Number(res.pageInfo.total)
        }
      })
    },
    exportTable(){
      let obj = {
        ...this.formItem,
        pageNo : 1,
        pageSize : 20000,
      }
      axios.post('IndexLibrary/selectIndexLibrary', obj).then(res=>{
        this.data2 = res.data
        this.$nextTick(()=>{
          this.$exportExcel('currentRowTable','指标库一览'+this.$nowDate.dateVal(new Date(),'YYYY-MM-DD HH-mm'));
        })
      })
      
    },
    pageChange(val){
      this.pageInfo.pageNo = val;
      this.search()
    }
  },
};
</script>

<style scoped>
.formRow {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}
.formCol {
  width: calc((100% - 210px) / 3);
  float: left;
  /* margin-right: 30px; */
}
@media screen and (max-width: 1300px) and (min-width: 800px) {
  .formCol {
    width: calc((100% - 40px) / 2);
  }
}
@media screen and (max-width: 800px) {
  .formCol {
    width: 100%;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/process/performanceManagement/IndexLibrary.vue